import { type FC } from 'react';

import GroupWorkOutlined from '@mui/icons-material/GroupWorkOutlined';

import { SideNavButton } from '@/src/components/atoms/navButtons';
import { NavDivider } from '@/src/components/molecules/CraftSideNav/NavDivider';
import { Pages } from '@/src/config/pages';

export const FacilitatorNavLinks: FC = () => (
  <>
    <NavDivider />
    <SideNavButton href={Pages.constructPath('learner-cohorts', {})} icon={GroupWorkOutlined}>
      Cohorts
    </SideNavButton>
    <NavDivider />
  </>
);
